import styles from './loadingSpiner.module.scss';
const LoadingSpinner = ({ className }: any) => {
    return (
        <div className={`${styles.spinnerContainer} ${className || ''}`}>
            <div className={styles.loader}></div>
        </div>
    );
};
export default LoadingSpinner;

